// ... autres erreurs existantes ...

export class ImageProcessingError extends Error {
  constructor(
    public code: string,
    message: string
  ) {
    super(message);
    this.name = 'ImageProcessingError';
  }
}

export const getImageErrorMessage = (error: ImageProcessingError): string => {
  const errorMessages: Record<string, string> = {
    INVALID_TYPE: 'Format d\'image non supporté. Utilisez JPG, PNG ou WebP',
    FILE_TOO_LARGE: 'L\'image ne doit pas dépasser 5MB',
    PROCESSING_ERROR: 'Erreur lors du traitement de l\'image',
    STORAGE_ERROR: 'Erreur lors du stockage de l\'image',
    INVALID_IMAGE: 'Image invalide ou corrompue',
    UNKNOWN_ERROR: 'Une erreur inattendue est survenue lors du traitement de l\'image'
  };

  return errorMessages[error.code] || error.message;
};